module.exports = __webpack_public_path__ + "img/Abschluss.0d021b6d.svg";